
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchEmployerCandidateJobApplyExportbyStatus } from "./employerCandidateJobApplyListByStatusExportAPI";

const initialState = {
    data: [],
    loading: false,
    error: null,
    status: 'idle', // Added status for better state tracking
};

// Async thunk with better error handling and logging
export const fetchEmployerCandidateJobApplyExportbyStatusAsync = createAsyncThunk(
    "employerCandidateJobApplyExport/fetch",
    async (payload, { rejectWithValue }) => {
        try {
            // console.log('Thunk payload:', payload);

            // Handle both string and object parameters
            const status = typeof payload === 'string' ? payload : payload?.status;
            // console.log('Extracted status:', status);

            const response = await fetchEmployerCandidateJobApplyExportbyStatus(status);
            // console.log('API response in thunk:', response);

            // Handle different response structures
            if (response?.status === 'success' && response?.response) {
                // console.log('Returning response.response:', response.response);
                return response.response;
            } else if (response?.data) {
                // console.log('Returning response.data:', response.data);
                return response.data;
            } else if (Array.isArray(response)) {
                // console.log('Returning response as array:', response);
                return response;
            } else {
                // console.log('Returning entire response:', response);
                return response;
            }

        } catch (error) {
            console.error('Thunk error:', error);
            return rejectWithValue(error.message || 'An error occurred while fetching data');
        }
    }
);

// Slice with improved reducers
const employerCandidateJobApplyExportbyStatusSlice = createSlice({
    name: "employerCandidateJobApplyExportbyStatus",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        resetState: (state) => {
            state.data = [];
            state.loading = false;
            state.error = null;
            state.status = 'idle';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployerCandidateJobApplyExportbyStatusAsync.pending, (state) => {
                // console.log('Thunk pending');
                state.loading = true;
                state.error = null;
                state.status = 'loading';
            })
            .addCase(fetchEmployerCandidateJobApplyExportbyStatusAsync.fulfilled, (state, action) => {
                // console.log('Thunk fulfilled with payload:', action.payload);
                state.loading = false;
                state.status = 'succeeded';
                state.data = Array.isArray(action.payload) ? action.payload : [];
                state.error = null;
            })
            .addCase(fetchEmployerCandidateJobApplyExportbyStatusAsync.rejected, (state, action) => {
                // console.log('Thunk rejected with error:', action.payload);
                state.loading = false;
                state.status = 'failed';
                state.error = action.payload || 'Failed to fetch data';
                state.data = [];
            });
    }
});

// Export actions
export const { clearError, resetState } = employerCandidateJobApplyExportbyStatusSlice.actions;

// Export reducer as default
export default employerCandidateJobApplyExportbyStatusSlice.reducer;